import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    "& .MuiIconButton-root": {
      padding: 0,
    },
  },
  input: {
    display: "none",
  },
}));

export default useStyles;
